(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["keico-delivery-enquiry"] && !Shopify.designMode) return;
  try {
    (() => {
  const safeText = (value, limit = 500) => typeof value === 'string' || typeof value === 'number' ? String(value).replace(/[\u0000-\u0008\u000b\u000c\u000e-\u001f\u007f]/g, '').slice(0, limit) : '';
  const safeId = (value) => /^\d{1,20}$/.test(String(value || '')) ? String(value) : '';
  const safeQuantity = (value) => /^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) && Number(value) > 0 ? String(value) : '1';
  const privateKey = /(^_|password|passcode|token|secret|authorization|cookie|captcha|credit|card.?number|email|phone|address|customer|recipient|gift.?message|personal|upload|file)/i;
  const safeProperties = (entries) => entries.flatMap(([key, value]) => {
    const label = safeText(key, 150).trim();
    const text = safeText(value, 1500).trim();
    return label && text && !privateKey.test(label) ? [[label, text]] : [];
  });
  const formProperties = (form) => {
    if (!form) return [];
    return safeProperties(Array.from(new FormData(form).entries()).flatMap(([key, value]) => {
      const match = /^properties\[([^\]]+)\]$/.exec(key);
      return match ? [[match[1], value]] : [];
    }));
  };
  const optionName = /^po_(?:checkbox|radio_button|swatch|dropdown(?:_thumbnail)?)(\d+)$/;
  const displayed = (element) => {
    for (let node = element; node && node !== document.body; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (node.hidden || node.getAttribute('aria-hidden') === 'true' || style.display === 'none' || style.visibility === 'hidden') return false;
    }
    return true;
  };
  const optionProperties = (root, source) => {
    const section = source.closest('.shopify-section');
    if (!section || root.closest('.shopify-section') !== section) return [];
    const groups = new Map();
    section.querySelectorAll('.bss-po-option-set input, .bss-po-option-set select, .bss-po-product-page input, .bss-po-product-page select').forEach((control) => {
      const match = optionName.exec(control.name || '');
      const app = control.closest('.bss-po-option-set, .bss-po-product-page');
      if (!match || !app || control.closest('.shopify-section') !== section || control.matches(':disabled') || control.closest('[data-keico-delivery]')) return;
      const owner = app.closest('[data-product-id]');
      if (owner && safeId(owner.dataset.productId) && safeId(owner.dataset.productId) !== safeId(root.dataset.productId)) return;
      if (control.tagName !== 'SELECT' && (!['checkbox', 'radio'].includes(control.type) || !control.checked)) return;
      const label = app.querySelector(`[id="po_label${match[1]}"]`);
      if (!label || !displayed(label) || !displayed(control.parentElement)) return;
      const title = safeText(label.textContent, 150).replace(/\s+/g, ' ').replace(/\s*\*\s*$/, '').trim();
      const values = control.tagName === 'SELECT' ? Array.from(control.selectedOptions).filter((option) => !option.disabled && option.value).map((option) => option.textContent) : [control.value];
      for (const [key, value] of safeProperties(values.map((value) => [title, value]))) {
        if (!groups.has(key)) groups.set(key, new Set());
        groups.get(key).add(value);
      }
    });
    return Array.from(groups, ([key, values]) => [key, Array.from(values).join(', ')]);
  };
  const cartSummary = (cart, labels) => {
    if (!cart || !Array.isArray(cart.items)) throw new Error('Invalid cart response');
    return cart.items.map((item, index) => {
      const components = Array.isArray(item.item_components) ? item.item_components.filter((entry) => entry && typeof entry === 'object') : [];
      const lines = [`${components.length ? labels.bundle : labels.item} ${index + 1}: ${safeText(item.product_title || item.title)}`, `${labels.variant}: ${safeText(item.variant_title || '')}`, `${labels.product_id}: ${safeId(item.product_id)}; ${labels.variant_id}: ${safeId(item.variant_id)}`, `${labels.sku}: ${safeText(item.sku)}; ${labels.quantity}: ${safeQuantity(item.quantity)}`];
      const properties = item.properties && !Array.isArray(item.properties) && typeof item.properties === 'object' ? Object.entries(item.properties) : [];
      for (const [key, value] of safeProperties(properties)) lines.push(`${key}: ${value}`);
      components.forEach((component, componentIndex) => {
        lines.push(`${labels.component} ${componentIndex + 1}: ${safeText(component.product_title || component.title)}`, `${labels.variant}: ${safeText(component.variant_title || '')}`, `${labels.product_id}: ${safeId(component.product_id)}; ${labels.variant_id}: ${safeId(component.variant_id)}`, `${labels.sku}: ${safeText(component.sku)}; ${labels.quantity}: ${safeQuantity(component.quantity)}`);
        const selected = component.properties && !Array.isArray(component.properties) && typeof component.properties === 'object' ? Object.entries(component.properties) : [];
        for (const [key, value] of safeProperties(selected)) lines.push(`${key}: ${value}`);
      });
      return lines.join('\n');
    }).join('\n\n');
  };
  const getJSON = async (url) => {
    const target = new URL(url, window.location.origin);
    if (target.origin !== window.location.origin) throw new Error('Invalid origin');
    const response = await fetch(target.href, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(8000) });
    if (!response.ok) throw new Error('Request failed');
    return response.json();
  };
  const init = (scope) => {
    scope.querySelectorAll('[data-keico-delivery]').forEach((root) => {
      if (root.dataset.deliveryReady) return;
      root.dataset.deliveryReady = 'true';
      const status = root.querySelector('[data-delivery-status]');
      const panel = root.querySelector('[data-delivery-panel]');
      if (status) { if (panel) panel.open = true; status.focus(); }
      const form = root.querySelector('.keico-delivery__form');
      if (!form) return;
      const labels = root.querySelector('[data-delivery-labels]').dataset;
      const field = (name) => root.querySelector(`[data-delivery-${name}]`);
      const context = field('context');
      const message = field('context-status');
      const refreshButton = field('refresh');
      if (!context || !refreshButton) return;
      const productForm = () => document.getElementById(root.dataset.productForm);
      let productData;
      let working = false;
      let selectedKey = '';
      let userEdited = false;
      let confirmedProduct = field('product').value;
      let confirmedVariant = field('variant').value;
      let queuedRefresh = false;
      let loadedOnce = false;
      const set = (name, value) => { const input = field(name); if (input) input.value = safeText(value, 16000); };
      const captureSelection = async (force = false) => {
        const source = productForm();
        if (!source) return;
        const data = new FormData(source);
        const variantId = safeId(data.get('id'));
        const quantity = safeQuantity(data.get('quantity') || 1);
        const properties = Array.from(new Map([...formProperties(source), ...optionProperties(root, source)]));
        const key = JSON.stringify([variantId, quantity, properties]);
        if (!force && (key === selectedKey || userEdited)) return;
        if (!root.dataset.productHandle || !variantId) return;
        const productUrl = new URL(root.dataset.productUrl, window.location.origin);
        if (productUrl.origin !== window.location.origin || !/\/products\/[^/]+$/.test(productUrl.pathname)) throw new Error('Invalid product URL');
        productData ||= await getJSON(`${productUrl.pathname}.js`);
        if (!Array.isArray(productData.variants) || safeId(productData.id) !== safeId(root.dataset.productId)) throw new Error('Invalid product response');
        const variant = productData.variants.find((entry) => safeId(entry.id) === variantId);
        if (!variant) throw new Error('Variant not found');
        if (!force && userEdited) return;
        set('product', productData.title);
        set('variant', variant.title === 'Default Title' ? '' : variant.title);
        set('product-id', productData.id);
        set('variant-id', variantId);
        set('sku', variant.sku || '');
        set('quantity', quantity);
        productUrl.searchParams.set('variant', variantId);
        set('product-url', productUrl.href);
        set('configuration', properties.map(([key, value]) => `${key}: ${value}`).join('\n'));
        selectedKey = key;
        confirmedProduct = safeText(productData.title);
        confirmedVariant = variant.title === 'Default Title' ? '' : safeText(variant.title);
        userEdited = false;
      };
      const refresh = async (force = false) => {
        if (working) { queuedRefresh = true; return; }
        working = true;
        refreshButton.disabled = true;
        message.textContent = labels.loading;
        try {
          const [, cart] = await Promise.all([captureSelection(force), getJSON(root.dataset.cartUrl)]);
          const summary = cartSummary(cart, labels);
          if (!productForm() && cart.items.length && !field('product').value) set('product', labels.cart_request);
          field('cart').value = summary;
          field('cart-preview').textContent = summary || labels.empty;
          message.textContent = labels.ready;
          loadedOnce = true;
        } catch (_) {
          field('cart').value = '';
          field('cart-preview').textContent = labels.failed;
          loadedOnce = false;
          message.textContent = labels.failed;
        } finally {
          refreshButton.disabled = false;
          working = false;
          if (queuedRefresh) { queuedRefresh = false; refresh(false); }
        }
      };
      context.hidden = false;
      refreshButton.addEventListener('click', () => refresh(true));
      if (panel) panel.addEventListener('toggle', () => { if (panel.open) refresh(false); });
      else refresh(false);
      document.addEventListener('change', (event) => {
        const source = productForm();
        const optionChanged = source && optionName.test(event.target.name || '') && event.target.closest('.bss-po-option-set, .bss-po-product-page') && event.target.closest('.shopify-section') === source.closest('.shopify-section');
        if (((event.target.form && event.target.form === source) || optionChanged) && (!panel || panel.open)) refresh(false);
      });
      form.addEventListener('input', (event) => {
        if (['product', 'variant', 'quantity', 'configuration'].some((name) => event.target === field(name))) userEdited = true;
      });
      form.addEventListener('submit', () => {
        if (confirmedProduct && (field('product').value !== confirmedProduct || field('variant').value !== confirmedVariant)) {
          for (const name of ['product-id', 'variant-id', 'sku', 'product-url']) set(name, '');
        }
        if (!loadedOnce) field('cart').value = '';
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  const observe = () => new MutationObserver((changes) => {
    for (const change of changes) for (const node of change.addedNodes) {
      if (node.nodeType === 1 && (node.matches('[data-keico-delivery]') || node.querySelector('[data-keico-delivery]'))) init(node.parentElement || document);
    }
  }).observe(document.body, { childList: true, subtree: true });
  if (document.body) observe();
  else document.addEventListener('DOMContentLoaded', observe, { once: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["keico-salt-enquiry"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialiseSaltRooms = (scope) => {
      scope.querySelectorAll('[data-keico-salt-room]').forEach((room) => {
        if (room.dataset.saltReady) return;
        room.dataset.saltReady = 'true';
        const header = document.getElementById('shopify-section-header');
        const updateHeaderOffset = () => {
          if (!header) return;
          const headerStyle = window.getComputedStyle(header);
          const isOverlay = headerStyle.position === 'sticky' || headerStyle.position === 'fixed';
          const headerHeight = isOverlay ? header.getBoundingClientRect().height : 0;
          const headerTop = isOverlay ? Math.max(0, parseFloat(headerStyle.top) || 0) : 0;
          room.style.setProperty('--salt-header-offset', `${Math.ceil(headerHeight + headerTop + 24)}px`);
        };
        updateHeaderOffset();
        if (header && 'ResizeObserver' in window) {
          const headerObserver = new ResizeObserver(updateHeaderOffset);
          headerObserver.observe(header);
          document.addEventListener('shopify:section:unload', (event) => {
            if (event.target.contains(room)) headerObserver.disconnect();
          }, { once: true });
        }
        room.addEventListener('click', (event) => {
          if (event.target.closest('a[href="#salt-room-enquiry"], a[href="#salt-room-details"]')) updateHeaderOffset();
        }, true);
        if (window.location.hash === '#salt-room-enquiry' || window.location.hash === '#salt-room-details') {
          requestAnimationFrame(() => room.querySelector(window.location.hash)?.scrollIntoView({ block: 'start' }));
        }
        const formStatus = room.querySelector('[data-salt-form-status]');
        if (formStatus) formStatus.focus();
        const rail = room.querySelector('[data-salt-gallery]');
        const controls = room.querySelector('[data-salt-controls]');
        if (!rail || !controls) return;
        const slides = Array.from(rail.querySelectorAll('[data-salt-slide]'));
        const thumbs = Array.from(room.querySelectorAll('[data-salt-thumbnail]'));
        const previous = room.querySelector('[data-salt-previous]');
        const next = room.querySelector('[data-salt-next]');
        const count = room.querySelector('[data-salt-current]');
        let current = 0;
        let pendingFrame = false;
        const showSlide = (index) => {
          const bounded = Math.max(0, Math.min(slides.length - 1, index));
          rail.scrollTo({ left: rail.clientWidth * bounded, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        const update = () => {
          current = Math.max(0, Math.min(slides.length - 1, Math.round(rail.scrollLeft / rail.clientWidth)));
          count.textContent = String(current + 1);
          previous.disabled = current === 0;
          next.disabled = current === slides.length - 1;
          thumbs.forEach((thumb, index) => {
            if (index === current) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
          slides.forEach((slide, index) => { slide.tabIndex = index === current ? 0 : -1; });
          pendingFrame = false;
        };
        thumbs.forEach((thumb, index) => thumb.addEventListener('click', (event) => { event.preventDefault(); showSlide(index); }));
        previous.addEventListener('click', () => showSlide(current - 1));
        next.addEventListener('click', () => showSlide(current + 1));
        rail.addEventListener('scroll', () => { if (!pendingFrame) { pendingFrame = true; requestAnimationFrame(update); } }, { passive: true });
        rail.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); showSlide(current + (event.key === 'ArrowRight' ? 1 : -1)); }
        });
        controls.hidden = false;
        update();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseSaltRooms(document));
    else initialiseSaltRooms(document);
    document.addEventListener('shopify:section:load', (event) => initialiseSaltRooms(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
